import React from "react";

const RetailerManagementList = React.lazy(() => import('src/pages/retailer_management/RetailerManagementList'));
const AddRetailerManagement = React.lazy(() => import('src/pages/retailer_management/AddRetailerManagement'));
const EditRetailerManagement = React.lazy(() => import('src/pages/retailer_management/EditRetailerManagement'));
const RetailerCardCustomers = React.lazy(() => import('src/pages/retailer_management/RetailerCardCustomers'));

const routes = [
    { path: '/dashboard/retailer-management-list/add', name: 'Add', element: AddRetailerManagement },
    { path: '/dashboard/retailer-management-list/edit', name: 'Edit', element: EditRetailerManagement },
    { path: '/dashboard/retailer-management-list/:retailer_id/card-customers', name: 'Card Customers', element: RetailerCardCustomers },
    { path: '/dashboard/retailer-management-list', name: 'Retailer Management', element: RetailerManagementList },
];

export default routes;